import { useEffect, useState } from 'react';
import { supabase } from '../config/supabase';

export const useMediaLinks = () => {
  const [links, setLinks] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMediaLinks = async () => {
      try {
        setLoading(true);
        setError(null);

        const { data, error: fetchError } = await supabase
          .from('media')
          .select('whatsapp_url, instagram_url, x_url')
          .limit(1)
          .maybeSingle();

        if (fetchError) {
          throw fetchError;
        }

        setLinks(data ?? null);
      } catch (err) {
        console.error('Error fetching media links:', err);
        setError(err.message || 'Failed to load media links');
        setLinks(null);
      } finally {
        setLoading(false);
      }
    };

    fetchMediaLinks();
  }, []);

  return { links, loading, error };
};

